jQuery(document).ready(function ($) {

    isSmallMobile = {
        any: function () {
            return $(window).width() < 767;
        }
    };

    function customPager() {
        $.each(this.owl.owlItems, function (i) {
            var titleData = jQuery(this).find('.item').data('model');
            var paginationLinks = jQuery.find('#models .owl-controls .owl-pagination .owl-page span');
            $(paginationLinks[i]).prepend(titleData);
        });
    }

    // Place Homepage only Javascript inside of IF statement - will be moved into shared Js/functions file.
    if (document.body.classList.contains('home')) {

        // *************************************************************************************************
        //	Hero Overlay, Style 8
        // *************************************************************************************************
        
        if ($(window).width() > 767) {
            setTimeout(function() {
                $("#homepage-advanced-search select").selectpicker({ dropupAuto: false });
                $("body").live('search_filters_rendered', function() {
                    $("#homepage-advanced-search select").selectpicker('refresh');
                });
                $("#homepage-advanced-search .filters").fadeIn();
        
                // Fix for missing type="combobox" on bootstrap buttons
                $('button.selectpicker').attr('type', 'combobox');
            }, 600);
        }


        // *************************************************************************************************
        //	Featured Section - Inventory, Style 1
        // *************************************************************************************************

        var featured_slider = new Swiper('.featuredCarousel', {
			speed: 300,
			spaceBetween: 30,
			watchOverflow: true,
			navigation : {
				nextEl : '.featuredSection .swiper-button-next.featured',
				prevEl : '.featuredSection .swiper-button-prev.featured'
			},
			slidesPerGroup: 3,
			slidesPerView: 3,
			breakpoints: {
				1024: {
					slidesPerGroup: 2,
					slidesPerView: 2
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
			preloadImages: false
		});


        // *************************************************************************************************
        //	Model, Style 10
        // *************************************************************************************************

        var models_slider = new Swiper('.modelSection .swiper-container', {
			speed: 300,
			slidesPerGroup: 2,
			slidesPerView: 2,
			spaceBetween: 24,
			preloadImages: false,
			navigation: {
				nextEl: '.modelSection .swiper-button-next.model',
				prevEl: '.modelSection .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 1,
					slidesPerView: 1,
                    spaceBetween: 0
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1,
                    spaceBetween: 0
				},
			},
		});


        // *************************************************************************************************
        //	Finance & Lease Section - Content, Style 6, Variant 2 & Inventory, Style 1
        // *************************************************************************************************

        var inventory_slider = new Swiper('.inventoryCarousel', {
			speed: 300,
			spaceBetween: 30,
			watchOverflow: true,
			navigation : {
				nextEl : '.promoSection .swiper-button-next.inventory',
				prevEl : '.promoSection .swiper-button-prev.inventory'
			},
			slidesPerGroup: 3,
			slidesPerView: 3,
			breakpoints: {
				1024: {
					slidesPerGroup: 2,
					slidesPerView: 2
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
			preloadImages: false
		});

    }



    // VEHICLE SPECIALS
    var owlSpecials = $('#vehicleSpecials').owlCarousel({
        autoPlay: 7000,
        navigation: true,
        singleItem: true,
        items: 1,
        beforeMove: function () {
            // lazyload hidden owl carousel items when they come into view
            if (typeof LazyLoad === "function") {
                var myLazyLoad = new LazyLoad();
            }
        }
    });
});
